const consentManagementModule = require('./consentManagement'),
	priceFloorsModule = require('./priceFloors');

function getModuleConfig(config) {
	const prebidModuleConfig = JSON.parse(JSON.stringify(config.additionalConfig));

	consentManagementModule.apply(prebidModuleConfig, config);
	priceFloorsModule.apply(prebidModuleConfig, config);

	return prebidModuleConfig;
}

module.exports = {
	getModuleConfig
};
